import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  Output,
  PLATFORM_ID,
  Renderer2,
} from '@angular/core';

export type PssAlertModalVariant = 'warning' | 'error' | 'info';

@Component({
  selector: 'app-pss-alert-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pss-alert-modal.component.html',
  styleUrl: './pss-alert-modal.component.css',
})
export class PssAlertModalComponent implements AfterViewInit, OnDestroy {
  @Input() title = 'แจ้งเตือน';
  @Input() message = '';
  @Input() confirmLabel = 'ตกลง';
  @Input() variant: PssAlertModalVariant = 'info';
  @Input() icon = '';

  @Output() close = new EventEmitter<void>();

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  get resolvedIcon(): string {
    if (this.icon?.trim()) return this.icon.trim();
    switch (this.variant) {
      case 'warning':
        return 'warning_amber';
      case 'error':
        return 'error_outline';
      default:
        return 'info';
    }
  }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.renderer.appendChild(this.document.body, this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const parent = this.elementRef.nativeElement.parentNode;
    if (parent) {
      this.renderer.removeChild(parent, this.elementRef.nativeElement);
    }
  }

  onClose(): void {
    this.close.emit();
  }
}
